import { Box, Grid, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives/index";
import { localize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

import { PersonalInfo } from "./PersonalInfo";
import { useSmartrrTheme } from "../../../hooks/useSmartrrTheme";

export const Settings = (): JSX.Element => {
  const theme = useSmartrrTheme();
  const showSectionTitles = theme.modernThemeSettings?.showHide.showSectionTitles;

  return (
    <Box className={prefixClassName("settings-container")}>
      <span className="anchor" id="settings" />
      {showSectionTitles ? <Typography variant="h2">{localize("settings.title")}</Typography> : null}
      <Grid container spacing={"20px"} className={prefixClassName("settings-container-inner")}>
        <Grid item xs={12} md={4} className={prefixClassName("settings-personal-information-card")}>
          <PersonalInfo />
        </Grid>
      </Grid>
    </Box>
  );
};
